// extracted by mini-css-extract-plugin
export var badge = "styles-module--badge--3c5a5";
export var body = "styles-module--body--d73d4";
export var button = "styles-module--button--df822";
export var content = "styles-module--content--5eee0";
export var description = "styles-module--description--bda38";
export var growable = "styles-module--growable--7793e";
export var h1 = "styles-module--h-1--90cd9";
export var h2 = "styles-module--h-2--bdeae";
export var h3 = "styles-module--h-3--b2af9";
export var h4 = "styles-module--h-4--c5896";
export var h5 = "styles-module--h-5--24fbd";
export var h6 = "styles-module--h-6--6e2da";
export var highlighted = "styles-module--highlighted--a9802";
export var icon = "styles-module--icon--d7ca8";
export var image = "styles-module--image--fcb72";
export var p1 = "styles-module--p-1--e4570";
export var p2 = "styles-module--p-2--02040";
export var p3 = "styles-module--p-3--e091a";
export var p4 = "styles-module--p-4--ec552";
export var title = "styles-module--title--00017";
export var withBadge = "styles-module--withBadge--a8912";
export var wrapper = "styles-module--wrapper--4d3a5";